import Helmet from 'react-helmet'
import React from 'react'
import styled from 'styled-components'

import Container from '../components/container'
import logo from '../images/tb-logo.png'

const StyledBillboard = styled.div`
  align-items: center;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;

  @media (max-width: 800px) {
    align-items: flex-start;
    flex-flow: column-reverse wrap;
    justify-content: flex-start;
  }
`

const StyledHeader = styled.h1`
  border-bottom: none;
  color: #333366;
  font-size: 3rem;
  line-height: 3rem;
`

const StyledLogo = styled.img`
  filter: blur(4px);
  padding: 1rem;

  @media (max-width: 800px) {
    filter: blur(2px);
    height: 92px;
    width: 92px;
  }
`

const StyledSubHeader = styled.h2`
  font-weight: bold;
  line-height: 2rem;
  margin: 3rem 0 1rem 0;
`

export default () => (
  <Container>

    <Helmet
      title={`Tom Bowden’s Personal Website`}
    >
      <style type="text/css">
        {`
          body {
            background-color: #fffff8;
          }
        `}
      </style>
    </Helmet>

    <StyledBillboard>
      <StyledHeader>Tom Bowden</StyledHeader>
      <StyledLogo alt="Tom Bowden’s logo" src={logo} />
    </StyledBillboard>

    <StyledSubHeader>Changing the way people learn languages</StyledSubHeader>

    <p>
      Welcome to my personal webpage. I’m a cofounder of <a href="http://www.mirai-llp.com">Mirai LLP</a>. 
      Mirai specializes in creating mobile applications, especially iOS apps, 
      for language learning. I believe that mobile apps are an invaluable tool for helping people learn. 
      Mirai’s language learning applications have been downloaded over a million times on the 
      iTunes App Store. Regularly featured by Apple, the extremely popular <strong>iStart</strong> series 
      of iPhone apps (<a href="http://www.miraifrench.com/">French</a>, <a href="http://www.miraichinese.com/">{" "}Chinese</a>, 
      <a href="http://www.miraigerman.com/">{" "}German</a>, <a href="http://www.miraikorean.com/">{" "}Korean</a>), 
      are affordable and highly effective language learning tools.
    </p>
    
    <p>
      Due to exceptional customer demand, the iStart apps for <b>Spanish</b>{" "} 
      and <b>Japanese</b> have been extended, updated, and rebranded as{" "}
      <a href="https://itunes.apple.com/us/app/mirai-spanish/id337250660?mt=8&uo=4&at=10l6cL" target="itunes_store">Mirai Spanish</a> and{" "}
      <a href="https://itunes.apple.com/us/app/mirai-japanese/id337246927?mt=8&uo=4&at=10l6cL" target="itunes_store">Mirai Japanese</a>. 
      These two apps are now being offered as subscription-based apps on both iOS and Android.
    </p>
   
    <p>
      At Mirai, we have fostered a strong partnership with Collins Dictionaries 
      (part of HarperCollins Publishers), creating the <strong>WordUP</strong> series &mdash; 
      the most powerful and effective bilingual dictionaries 
      and phrase books ever made for <a href="http://www.apple.com/ios/">iOS</a>, 
      optimized for both iPhone and iPad. To date, we have published the following 
      bilingual language dictionary and phrasebook apps:
    </p>
    
    <p>
      <a href="http://itunes.apple.com/app/wordup-arabic-mirai-language/id498455335?l=en&mt=8">Arabic</a>{" ・ "}
      <a href="http://itunes.apple.com/app/wordup-chinese-mandarin-mirai/id479811753?l=en&mt=8">Chinese (Mandarin)</a>{" ・ "}
      <a href="http://itunes.apple.com/app/wordup-croatian-mirai-language/id498458986?l=en&mt=8">Croatian</a>{" ・ "}
      <a href="http://itunes.apple.com/app/wordup-czech-mirai-language/id498455853?l=en&mt=8">Czech</a>{" ・ "}
      <a href="http://itunes.apple.com/app/wordup-danish-mirai-language/id498456164?l=en&mt=8">Danish</a>{" ・ "}
      <a href="http://itunes.apple.com/app/wordup-dutch-mirai-language/id498459038?l=en&mt=8">Dutch</a>{" ・ "}
      <a href="http://itunes.apple.com/app/wordup-finnish-mirai-language/id498458571?l=en&mt=8">Finnish</a>{" ・ "}
      <a href="http://itunes.apple.com/app/wordup-french-mirai-language/id479810592?l=en&mt=8">French</a>{" ・ "}
      <a href="http://itunes.apple.com/app/wordup-german-mirai-language/id479811155?l=en&mt=8">German</a>{" ・ "}
      <a href="http://itunes.apple.com/app/wordup-greek-mirai-language/id498456513?l=en&mt=8">Greek</a>{" ・ "}
      <a href="http://itunes.apple.com/app/wordup-italian-mirai-language/id479811104?l=en&mt=8">Italian</a>{" ・ "}
      <a href="http://itunes.apple.com/app/wordup-japanese-mirai-language/id436695129?l=en&mt=8">Japanese</a>{" ・ "}
      <a href="http://itunes.apple.com/app/wordup-korean-mirai-language/id479812242?l=en&mt=8">Korean</a>{" ・ "}
      <a href="http://itunes.apple.com/app/wordup-norwegian-mirai-language/id498459384?l=en&mt=8">Norwegian</a>{" ・ "}
      <a href="http://itunes.apple.com/app/wordup-polish-mirai-language/id498459583?l=en&mt=8">Polish</a>{" ・ "}
      <a href="http://itunes.apple.com/app/wordup-portuguese-brazilian/id479811578?l=en&mt=8">Portuguese (Brazilian)</a>{" ・ "}
      <a href="http://itunes.apple.com/app/wordup-portuguese-iberian/id498459740?l=en&mt=8#">Portuguese (Iberian)</a>{" ・ "}
      <a href="http://itunes.apple.com/app/wordup-russian-mirai-language/id498459839?l=en&mt=8">Russian</a>{" ・ "}
      <a href="http://itunes.apple.com/app/wordup-spanish-iberian-mirai/id498456526?l=en&mt=8">Spanish (Iberian)</a>{" ・ "}
      <a href="http://itunes.apple.com/app/wordup-spanish-latin-american/id479810041?l=en&mt=8">Spanish (Latin American)</a>{" ・ "}
      <a href="http://itunes.apple.com/app/wordup-swedish-mirai-language/id498460048?l=en&mt=8">Swedish</a>{" ・ "}
      <a href="http://itunes.apple.com/app/wordup-thai-mirai-language/id498460255?l=en&mt=8">Thai</a>{" ・ "}
      <a href="http://itunes.apple.com/app/wordup-turkish-mirai-language/id498460303?l=en&mt=8">Turkish</a>{" ・ "}
      <a href="http://itunes.apple.com/app/wordup-vietnamese-mirai-language/id498460429?l=en&mt=8">Vietnamese</a>
    </p>
    
    <p>
      We are also in partnership with Hodder Education 
      (part of Hachette), adapting the extremely popular <strong>In A Day</strong> series, 
      written by <a href="http://www.elisabeth-smith.co.uk/">Elisabeth Smith</a>. 
      Using a very entertaining and practical approach, Elisabeth has helped people 
      all around the world learn the basics of the language of the country they 
      are traveling to on vacation, and in doing so has sold over one million 
      copies of her books, CDs, and DVDs. Mirai has released the following 
      language courses by Elisabeth Smith as beautifully designed and illustrated 
      apps:
    </p>

    <p>
      <a href="http://itunes.apple.com/app/spanish-in-day-elisabeth-smith/id495883038?l=en&mt=8">Spanish In A Day</a>{" ・ "}
      <a href="http://itunes.apple.com/app/french-in-day-elisabeth-smith/id495882578?l=en&mt=8">French In A Day</a>{" ・ "}
      <a href="http://itunes.apple.com/app/german-in-day-elisabeth-smith/id495883211?l=en&mt=8">German In A Day</a>{" ・ "}
      <a href="http://itunes.apple.com/app/italian-in-day-elisabeth-smith/id495882548?l=en&mt=8">Italian In A Day</a>{" ・ "}
      <a href="http://itunes.apple.com/app/portuguese-in-day-elisabeth/id495883386?l=en&mt=8">Portuguese In A Day</a>{" ・ "}
      <a href="http://itunes.apple.com/app/mandarin-chinese-in-day-elisabeth/id495883281?l=en&mt=8">Mandarin Chinese In A Day</a>{" ・ "}
      <a href="http://itunes.apple.com/app/greek-in-day-elisabeth-smith/id495883371?l=en&mt=8">Greek In A Day</a>{" ・ "}
      <a href="http://itunes.apple.com/app/polish-in-day-elisabeth-smith/id495883535?l=en&mt=8">Polish In A Day</a>{" ・ "}
      <a href="http://itunes.apple.com/app/turkish-in-day-elisabeth-smith/id495883434?l=en&mt=8">Turkish In A Day</a>
    </p>
  
    <StyledSubHeader>Personal Bio</StyledSubHeader>
    <ul>
      <li>
        Cofounder and Managing Partner at <a href="http://www.mirai-llp.com">Mirai LLP</a>, 
        an app design & development firm which was established in 2008, making innovative mobile 
        applications for language learning, and partnering with the leading global 
        publishers (<a href="http://www.harpercollins.com">HarperCollins</a>
        {" "}and{" "}<a href="http://www.hachettelivre.co.uk">Hachette</a>) for 
        language dictionaries and other language-related content
      </li>
      <li>
        Formerly: equity trader, registered equity market-maker on the 
        <a href="http://www.londonstockexchange.com/home/homepage.htm">{" "}LSE</a> and options trader on 
        <a href="http://en.wikipedia.org/wiki/London_International_Financial_Futures_and_Options_Exchange">{" "}LIFFE
        </a> (now NYSE Euronext); Executive Search for buy-side firms
      </li>
      <li>
        Formal education: <a href="http://www3.imperial.ac.uk">Imperial College</a> (Physics), 
        <a href="http://www.st-andrews.ac.uk">{" "}St Andrews University</a> (Philosophy),{" "}
        <a href="http://www.city.ac.uk">City University</a> (Economics), <a href="http://www.cass.city.ac.uk">Cass Business School
        </a> (<a href="http://www.cass.city.ac.uk/courses/masters/courses/mathematical-trading-and-finance">
        MSc Mathematical Trading &amp; Finance</a>)
      </li>
      <li>
        Interests: human-application interaction design, linguistics and 
        phonetics, information design, equity valuation, MOOCs, mobile and web technologies,
        machine learning, and autonomous car technologies.
      </li>
    </ul>
  
    <StyledSubHeader>Contact</StyledSubHeader>
    <a href="mailto:tom@tbowden.net" className="email">
      Click here to contact me by email
    </a>

  </Container>
)



// WEBPACK FOOTER //
// ./src/pages/index.js